import assign from "lodash/assign";
import axios from "../../../config/axios";

export default {
  notasGenerar,
};

function notasGenerar(cliente, notas, params) {
  const body = assign({ notas, cliente, params }, params);
  return axios.post(
    `${axios.defaults.baseUrl}/api/reporte/nota/generar`, body,
    { responseType: "arraybuffer" },
  ).then(ok, err);
}

function ok(resp) {
  return resp.data;
}

function err(resp) {
  return resp;
}



// WEBPACK FOOTER //
// ./src/components/notas/rest/reporteApi.js